import { nursingHomeManager } from '$domain/model/nursingHome/nursingHome.manager'

export const getResidentsList = () => nursingHomeManager.recoverResidents()



// WEBPACK FOOTER //
// ./src/services/nursingHome/residents/getResidentsList.services.ts